import { getSavedPin, removeSavedPin, savePin } from '@/lib/savedPins'

/**
 * Edicao de uma sala fixa, do jeito que o servidor espera.
 *
 * Vive aqui, e nao dentro de um hook, porque dois lugares editam a mesma sala:
 * a tela inicial (pela lista de salas do dono) e a propria sala (pelo dono que
 * ja esta dentro dela).
 */

export interface RoomUpdate {
    name?: string
    /** Endereco novo. Trocar quebra o link antigo, entao so vai quando pedido. */
    code?: string
    /** Ausente mantem o PIN, string vazia remove, string troca. */
    pin?: string
}

export interface RoomUpdateResult {
    ok: boolean
    /** Endereco depois da edicao — muda quando o dono troca o endereco. */
    code?: string
    error?: string
}

export async function patchPermanentRoom(code: string, fields: RoomUpdate): Promise<RoomUpdateResult> {
    try {
        const response = await fetch(`/api/rooms/${encodeURIComponent(code)}`, {
            method: 'PATCH',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(fields)
        })
        const data = await response.json().catch(() => ({})) as { code?: string; error?: string }

        if (!response.ok) return { ok: false, error: data.error }

        const codigoFinal = data.code ?? code
        sincronizarPinSalvo(code, codigoFinal, fields.pin)
        return { ok: true, code: codigoFinal }
    } catch {
        return { ok: false, error: 'network' }
    }
}

/**
 * O PIN guardado nesta maquina e amarrado ao ENDERECO da sala.
 *
 * Trocar o PIN sem atualizar aqui faria a propria dona da sala levar "PIN
 * incorreto" no proximo clique; trocar o ENDERECO sem mover o registro deixaria
 * o PIN salvo apontando pra um endereco que nao existe mais.
 */
function sincronizarPinSalvo(codeAntigo: string, codeNovo: string, pin: string | undefined): void {
    if (pin !== undefined) {
        removeSavedPin(codeAntigo)
        if (pin) savePin(codeNovo, pin)
        return
    }

    if (codeNovo === codeAntigo) return
    // PIN intocado, endereco novo: leva o que estava guardado junto.
    const guardado = getSavedPin(codeAntigo)
    removeSavedPin(codeAntigo)
    if (guardado) savePin(codeNovo, guardado)
}
